import { BoxOfferFormattedPrice } from "@modules/boxOffer/components/boxOfferFormSection"
import { BoxOfferDetailedEntity, BoxOfferItemEntity } from "@modules/boxOffer/entities/boxOfferEntity"
import { Price } from "@modules/boxOffer/entities/boxOfferTypes"
import { word } from "@modules/core/utils/i18n"
import { HUTag } from "@modules/ui/components/huTag"
import { HUText } from "@modules/ui/components/huText"

type BoxOfferCardProps = {
  offer: BoxOfferItemEntity | BoxOfferDetailedEntity
  price?: Price
} & React.HTMLAttributes<HTMLDivElement>

export const BoxOfferCard = ({ offer, price, ...props }: BoxOfferCardProps) => {
  // Use box-offer-card-width class to set the width of the card for complexe layout
  const defaultClassName =
    "flex w-full h-9rem p-3 gap-4 border-round-xl border-1 border-neutralColor-300 justify-content-between cursor-pointer"
  return (
    <div className={props.className ?? defaultClassName} {...props}>
      <div className="flex w-7 flex-column justify-content-between gap-3">
        <HUText fontStyle="TM">{offer.name}</HUText>
        <HUText
          fontStyle="BS"
          className="overflow-y-auto"
          style={{ overflowWrap: "break-word", whiteSpace: "break-spaces" }}
        >
          {offer.description}
        </HUText>
      </div>
      <div className="flex flex-column justify-content-between align-items-end">
        <HUTag className={` ${offer.archived ? "bg-neutralColor-400" : "bg-primary-700"}`}>
          <HUText fontStyle="LL">{word(`box.offer.form.types.${offer.type}`)}</HUText>
        </HUTag>
        <div className="flex flex-column align-items-end pr-2">
          {price && (
            <BoxOfferFormattedPrice price={offer.price} lineThrough={true} wholePartStyle="BS" decimalPartStyle="BS" />
          )}
          <BoxOfferFormattedPrice price={price ?? offer.price} />
        </div>
      </div>
    </div>
  )
}
